import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExternalLinkIcon = _resolveComponent("ExternalLinkIcon")!

  return (_openBlock(), _createElementBlock("button", {
    class: "p-2 mt-1 md:text-base sm:text-sm font-semibold text-text-lighter focus:outline-none hover:text-primary",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDoi()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ExternalLinkIcon, { class: "h-5 w-5 mr-1" }),
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}